import Vue from "vue";
import Vuetify from "vuetify/lib";

import menu from "@/assets/icons/menu.vue";
import backward from "@/assets/icons/backward.vue";
import download from "@/assets/icons/download.vue";
import forward from "@/assets/icons/forward.vue";
import invisible from "@/assets/icons/invisible.vue";
import microphone from "@/assets/icons/microphone.vue";
import microphoneOn from "@/assets/icons/microphoneOn.vue";
import play from "@/assets/icons/play.vue";
import progress from "@/assets/icons/progress.vue";
import speaker from "@/assets/icons/speaker.vue";
import flipchart from "@/assets/icons/flipchart.vue";
import flipchart2 from "@/assets/icons/flipchart2.vue";
import grammar from "@/assets/icons/grammar.vue";
import letter from "@/assets/icons/letter.vue";
import visible from "@/assets/icons/visible.vue";
import lesson from "@/assets/icons/lesson.vue";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      appMenu: {
        component: menu,
      },
      appBackward: {
        component: backward,
      },
      appDownload: {
        component: download,
      },
      appForward: {
        component: forward,
      },
      appInvisible: {
        component: invisible,
      },
      appMicrophone: {
        component: microphone,
      },
      appMicrophoneOn: {
        component: microphoneOn,
      },
      appPlay: {
        component: play,
      },
      appProgress: {
        component: progress,
      },
      appSpeaker: {
        component: speaker,
      },
      appFlipchart: {
        component: flipchart,
      },
      appFlipchart2: {
        component: flipchart2,
      },
      appGrammar: {
        component: grammar,
      },
      appLetter: {
        component: letter,
      },
      appVisible: {
        component: visible,
      },
      appLesson: {
        component: lesson,
      },
    },
  },
});
